module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/54163bf1a436b31987f4f31334efe649.png";